define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/config",
	"csi/xml"
], function(declare, _, config, xml) {

	return declare(null, {

		/**
		 * Apply placement filters when RequireSectionForPlacement feature is enable.
		 * @param {Query} query
		 */
		_applyRequireSectionFiltersFromMaterial(query) {
			const applyFilter = function(queryOr, productType) {
				queryOr.RefAttr("ProductType", xml.OP_EQUALS, productType);
			}

			return this._applyRequireSectionForPlacementFilters(query, this.getParent(), applyFilter);
		},

		/**
		 * Apply placement filters when RequireSectionForPlacement feature is enable.
		 * Filters are related to Product type, and when the view PartMaterial
		 * it is necessary to identify the PATH to fetch the ProductType properly.
		 *
		 * @param {Query} query
		 */
		_applyRequireSectionFiltersFromPartMaterial(query) {
			const applyFilter = function(queryOr, productType) {
				queryOr.RefAttr("ProductType", xml.OP_EQUALS, productType, "Child:Actual")
			}

			return this._applyRequireSectionForPlacementFilters(query, this.getParent(), applyFilter);
		},

		/**
		 * Apply placement filters for Special Placements when RequireSectionForPlacement feature is enable.
		 *
		 * @param {Query} query
		 */
		_applyRequireSectionFiltersFromSpecialPartMaterial(query) {
			const applyFilter = function(queryOr, productType) {
				queryOr.Node("URL", xml.OP_EQUALS, productType);
			}

			const parentUrl = !this.formInfo ? this.viewParent.formInfo.parentUrl : this.formInfo.parentUrl;
			const bomRevision = this.getCache().get(parentUrl);

			return this._applyRequireSectionForPlacementFilters(query, bomRevision, applyFilter);
		},

		/**
		 * Apply placement filters when RequireSectionForPlacement feature is enable.
		 * @param {Query} query
		 * @param {C8Node} bomRevision
		 * @param {function} applyFilter apply query or filter with product type
		 * @private
		 */
		_applyRequireSectionForPlacementFilters(query, bomRevision, applyFilter) {
			const qOR = query.Or();

			if (!this._hasPlacementSectionFilter(bomRevision)) {
				return false;
			}

			const cache = this.getCache();
			const sections = bomRevision?.AllSections || [];

			sections.forEach((section) => {
				const bomSectionDef = cache.getNode(section);
				const appPlacementPTs = bomSectionDef?.PlacementProductTypes || [];

				appPlacementPTs.forEach((productType) => {
					applyFilter(qOR, productType);
				});
			});

			return true;
		},

		/**
		 * Verify if feature RequireSectionForPlacement is enabled and checks if one of the sections does not have filter.
		 * @return {boolean}
		 */
		_hasPlacementSectionFilter(bomRevision) {
			if (this._isRequireSectionForPlacement(bomRevision)) {
				return !this._hasPlacementSectionWithoutFilter(bomRevision);
			}

			return false;
		},

		_isRequireSectionForPlacement(bomRevision) {
			const parentID = bomRevision?.__Parent__;
			const bomRevisionType = bomRevision?.$Type;
			const isRequireSection = config.getSubtypeSetting(this.getCache().get(parentID).Subtype, "RequireSectionForPlacement");

			return bomRevisionType === "ApparelBOMRevision" && isRequireSection;
		},

		/**
		 * When one of the required sections have no filter selected all placements should be listed.
		 * Which means no filter for placements should be applied.
		 */
		_hasPlacementSectionWithoutFilter(bomRevision) {
			const cache = this.getCache();
			const sections = bomRevision?.AllSections || [];

			if (sections.length === 0) {
				return false;
			}

			for (const section of sections) {
				const bomSectionDef = cache.getNode(section);
				const appPlacementPTs = bomSectionDef?.PlacementProductTypes || [];

				if (appPlacementPTs.length === 0) {
					return true;
				}
			}

			return false;
		},

	});
});